import Prism from 'prismjs';
import 'prismjs/components/prism-scss';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/plugins/line-highlight/prism-line-highlight';
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace';
import 'prismjs/plugins/toolbar/prism-toolbar';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard';

import 'prismjs/themes/prism-tomorrow.min.css';
import 'prismjs/plugins/line-highlight/prism-line-highlight.min.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.min.css';
import 'prismjs/plugins/toolbar/prism-toolbar.min.css';

export default class TKCodeblock extends HTMLElement {
    languageType: string;
    contentId: string;
    lineNumbers?: boolean;
    lineHighlight?: string;

    constructor() {
        super();

        this.languageType = this.getAttribute('data-tk-type') || '';
        this.contentId = this.getAttribute('data-tk-content-id') || '';
        this.lineNumbers = this.hasAttribute('data-tk-line-numbers')
            ? Boolean(this.getAttribute('data-tk-line-numbers') === 'true')
            : false;
        this.lineHighlight = this.getAttribute('data-tk-line-highlight') || undefined;

        if (this.languageType === '') {
            throw new Error('TK: Missing Language Type');
        }

        if (this.contentId === '') {
            throw new Error('TK: Missing Content');
        }
    }

    connectedCallback(): void {
        // Create Elements
        const preElement = document.createElement('pre');
        const codeElement = document.createElement('code');

        if (this.lineNumbers) {
            preElement.setAttribute('class', 'line-numbers');
        }

        if (this.lineHighlight) {
            preElement.setAttribute('data-line', `${this.lineHighlight}`);
        }

        codeElement.setAttribute('class', `language-${this.languageType}`);

        // Get example-markup from hidden template-tag
        const template = document.querySelector<HTMLTemplateElement>(`#${this.contentId}`);
        if (!template) return;
        const templateContent = template.content;

        codeElement.appendChild(templateContent);
        preElement.appendChild(codeElement);

        // Append Code-Fragment to custom-element HTML-Tag
        this.appendChild(preElement);

        // Highlight Codeblock
        Prism.highlightElement(codeElement);
    }
}
